module.exports = __webpack_public_path__ + "img/chirpstack-gateway-bridge-large-light.2512c8fd.png";